import { render } from "./documentview.vue?vue&type=template&id=14854e1c&scoped=true"
import script from "./documentview.js?vue&type=script&lang=js"
export * from "./documentview.js?vue&type=script&lang=js"

import "./documentview.vue?vue&type=style&index=0&id=14854e1c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14854e1c"]])

export default __exports__